'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _zh_CN = require('../../date-picker/locale/zh_CN');

var _zh_CN2 = _interopRequireDefault(_zh_CN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _zh_CN2['default'];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/calendar/locale/zh_CN.js
// module id = 274
// module chunks = 0